const departmentTypeMap = require('./department-type-map');

const departmentTypeList = Object.keys(departmentTypeMap).sort();
module.exports = departmentTypeList;
